/* unplugin-vue-components disabled */import script from "./RecruitPersonnelList.vue?vue&type=script&setup=true&lang=js"
export * from "./RecruitPersonnelList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__